export enum ReferralStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'
}
